import template from './custom-tables.html';

/**
 * CustomTables class
 * Page for setting up all custom fields - uses the ko-field-table-builder component
*/

class CustomTablesViewModel
{
	constructor(page)
	{
		this.page = page;
		this.field_table_changes = null;
	}

	on_field_table_changes(changes)
	{
		this.field_table_changes = changes;
	}

	async btn_save_fields()
	{
		if (!this.field_table_changes)
			return;

		const FieldsTableModel = Grape.dataModel.get('fields.FieldsTable');
		const result = await FieldsTableModel.apply_pending_changes(this.field_table_changes);
		if (result.status === 'OK')
			Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Fields saved successfully!' });
		else
			Grape.alerts.alert({ type: 'error', title: 'Error', message: result.message });
	}
}

class CustomTablesClass
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.name = 'CustomTablesClass';
		this.viewModel = new CustomTablesViewModel(this);
		document.title = 'Setup Custom Tables';
	}

	async init() { }
}

export default {
	route: '[/]ui/setup/custom-tables',
	page_class: CustomTablesClass,
	template: template
};
